export const RemoveTokenFromLS = () => {
    window.localStorage.clear();
};
